import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";

/**
 * Gate for authenticated routes. If the user isn't authenticated, we
 * redirect to /login and stash the current location in state so Login
 * can send them back after a successful sign-in.
 */
export function ProtectedRoute({ children }) {
  const { authenticated } = useAuth();
  const location = useLocation();
  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
